import ApiService from '@/services/core/api.service'

const CampaignTrackerService = {
  async get () {
    return ApiService.get('agent/campaign-tracker')
  }
}

export default CampaignTrackerService
